const FOUNDATION_URL = {
  BASE: 'https://company.arirang.com/notice',
  1: '/announce/1',
  2: '/employ/2',
  3: '/bid/3',
  4: '/report/4',
  get(no) {
    return this.BASE.concat(this[no]);
  },
};

export default FOUNDATION_URL;
